import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const lob = defineConnector({
  identifier: "lob",
  name: "Lob",
  tagLine: "Direct mail and address verification",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.lob\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.username,
      password: "",
    }),
  steps: [
    {
      title: "Find your Lob API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Lob authentication docs](https://docs.lob.com/#tag/Authentication) and create or copy live or test API keys from your Lob dashboard. Use the key for the environment you want this connection to call.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content: "Enter the API credentials from your Lob account settings.",
        },
        {
          kind: "input",
          label: "Secret API Key",
          required: true,
          target: { kind: "secrets", field: "username" },
          placeholder: "test_0dc8d***************************5b0cc",
          helperText: "Your Lob Secret API Key.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.lob.com/v1/addresses",
  },
});
